<template>
<div data-module="work-main-header">
  <div class="color-block"
    :style="colorBlockStyles"
  />
  <div class="component-layout">
    <h1>Our<br/>Work.</h1>
    <p>We work at the intersection of technology, design, and culture. We create to be exceptional and unforgettable.</p>
  </div>
</div>
</template>


<script>
/*
  Work section Header module

  data record:
  {
    background: <string> // url
    title: <string>
    content: <markdown>
    roles: Array<string> //
  }
*/
// Constants
import { MaxBrowserWidth } from '@/app-constants';

export default {

  name: 'work-main-header',

  computed: {

    currentBrowserWidth() {
      return this.$store.state.width;
    },

    colorBlockStyles() {
      const { currentBrowserWidth } = this;
      let offset = 0;
      if (currentBrowserWidth > MaxBrowserWidth) {
        offset = (currentBrowserWidth - MaxBrowserWidth) * 0.5;
      }
      const style = {
        marginLeft: `-${offset}px`,
      };
      return style;
    },

  },
};
</script>


<style lang="scss" scoped>
@import '~@/styles/_grid.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';
@import '~@/styles/_variables.scss';


$width: $layout--optimal-desktop - (65*2);
$layout--percentage: $width / $layout--optimal-desktop * 100%;

[data-module="work-main-header"] {

  width: 100%;

  // media query props
  margin-top: rem(($height--nav-bar-mobile + 2) * 1px); // adjust for nav bar
  padding-bottom: rem(0px);

  @include ngMq($nbp--tablet, up) {
    margin-top: rem(($height--nav-bar-tablet + 10) * 1px);
    padding-bottom: rem(56px);
  }

  @include ngMq($nbp--desktop, up) {
    margin-top: rem(($height--nav-bar-desktop + 52) * 1px);
    padding-bottom: rem(30px);
  }

  .color-block {
    position: absolute;
    width: 100vw;
    bottom: 0;
    background-color: $color--quaternary-midtone;

    // media query props
    height: 0;

    @include ngMq($nbp--tablet, up) {
      height: 224px;
    }

    @include ngMq($nbp--desktop, up) {
      height: 200px;
    }
  }

  .component-layout {
    // media query props
    @include ngGrid('mobile');

    @include ngMq($nbp--tablet, up) {
      margin: 0 rem($grid-column-tablet * 0.5 * 1px);
      margin-top: 0;
      @include ngGrid('tablet');
    }

    @include ngMq($nbp--desktop, up) {
      margin: 0;
      @include ngGrid('desktop');
    }



    h1 {
      grid-column: 1 / span 7;

      // media query props
      @include serif( $size: (65, 64, -0.14), $weight: 'bold');
      margin-top: rem(62px);

      @include ngMq($nbp--tablet, up) {
        @include serif( $size: (65, 64, -0.14), $weight: 'bold');
        margin-top: rem(52px);
      }

      @include ngMq($nbp--desktop, up) {
        @include serif( $size: (101, 97, -0.21), $weight: 'bold');
        margin-top: rem(62px);
      }
    }

    p {
      // media query props
      grid-column: 1 / -1;
      margin-top: rem(52px - $grid-gap-mobile - 18);
      margin-bottom: rem(40px);

      @include ngMq($nbp--tablet, up) {
        grid-column: 1 / span 7;
        margin-top: rem(44px - $grid-gap-tablet - 18);
        margin-bottom: rem(76px - (18 + 38));
      }

      @include ngMq($nbp--desktop, up) {
        grid-column: 1 / span 5;
        margin-top: rem(58px - $grid-gap-desktop - 26);
        margin-bottom: rem(76px - (18 + 38));
        margin-right: rem($grid-gap-desktop * -1px); // pull to right, column
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/work/WorkHeader.vue